// extracted by mini-css-extract-plugin
export default {"more":"_2yvoQP1K","freelanceGig":"xibeyAjJ"};